export default __webpack_public_path__ + "static/spark_app_verify_account-e51e47d09840427aa11ff87441791459.png";